import { render, staticRenderFns } from "./printThirdPartyTagModal.vue?vue&type=template&id=645bf7c2&scoped=true&"
import script from "./printThirdPartyTagModal.vue?vue&type=script&lang=js&"
export * from "./printThirdPartyTagModal.vue?vue&type=script&lang=js&"
import style0 from "./printThirdPartyTagModal.vue?vue&type=style&index=0&id=645bf7c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645bf7c2",
  null
  
)

export default component.exports